import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, FormArray, Validators, FormControl } from '@angular/forms';
import { MultiInputStepComponent } from '../../step/multi-input-step/multi-input-step.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss', '../../step/step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class PhoneComponent extends MultiInputStepComponent implements OnInit {
  
  @ViewChild('phone') phoneField: ElementRef;
  @ViewChild("lenderList") lenderList: ElementRef;
  
  public title: string = "Enter your phone number and you're all done!";
  public experiment: boolean;
  public subtitle: string = "Complete This Final Step To Get Rates & Calculate Payment";
  public notDebtSettlement: boolean;
  public submitButtonText: string = 'Get My Rates';
  public finalLenders: any;
  public jornaya: boolean = false;
  isPreferBox = false;
  canEditScores: boolean = false;
  showLenderError: boolean = false;

  fruLocalKiosk: boolean;
  fruLocal: boolean;

  phoneMask: Object = {
    mask: '(#00) 000-0000',
    definitions: {'#': /[1-9]/}
  };

  // Not sure about all parameters but it give error and break phone
  // when I try to edit phone number
  // phoneMask: Object = {
  //   mask: [
  //     {
  //       mask: /^$/i,
  //       lazy: true
  //     },
  //     {
  //       mask: '(#00) 000-0000',
  //       definitions: {'#': /[1-9]/},
  //       lazy: false
  //     }
  //   ]
  // }

  ngOnInit() {
    this.fruLocalKiosk = this.communication.fruLocalKiosk;
    // Phone validation
    this.controls.push(new UntypedFormControl('', [Validators.required, Validators.pattern(/(\((?!000|111|200|222|300|333|400|444|500|555|600|666|700|777|900|999)\d{3}\) \d{3}-\d{4})|\d{10}/)]));
    // SMS validation
    this.controls.push(new UntypedFormControl(false));
    // Email Preference
    this.controls.push(new UntypedFormControl(false));
    // Spanish Preference
    this.controls.push(new UntypedFormControl(false));

    this.form.addControl('phoneNumber', this.controls[0]);
    this.form.addControl('sms', this.controls[1]);
    this.form.addControl('email_preference', this.controls[2]);
    this.form.addControl('prefers_spanish', this.controls[3]);

    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        if (variationData.enabledVariations.hasOwnProperty('prefBoxes')) {
          this.isPreferBox = true;
        }
      }
    );

    if (!environment.production) {
      this.canEditScores = true;
      this.form.controls.phoneNumber.setValue(this.randomService.consumer.phoneNumber.toString());
      this.form.addControl('phonescore_override', new FormControl());
      this.form.addControl('emailscore_override', new FormControl());
    }
  }

  initStep() {
    // Give zip code focus
    setTimeout(() => this.phoneField.nativeElement.focus(), 0);

    this.lenders.subscribe((lenders) => {
      if (lenders.length > 0) {
        this.finalLenders = lenders;
        setTimeout(() => {
          this.jornaya = true;
          this.checkLenders();
        }, 150);
      }
    });
  }

  checkLenders() {
    //Because jornaya apparently can't register the prechecked boxes after all
    //Need to load the opposite checked type for the lender then click it with js
    let element : any = this.lenderList.nativeElement;
    let checkboxes : any = element.querySelectorAll('input');
    checkboxes.forEach((checkbox) => {
      checkbox.click();
    });
    this.snap();
  }

  prefersSpanishSelected () {
    this.analyticsService.trackGoal(26);
    console.log('goal tracked');
    this.snap();
  }

  closeModal() {
    this.communication.modalClosed.emit(true);
  }

  phoneChange($event) {
    this.snap();
    this.checkPhoneLength($event.target.value);
  }

  phoneInput($event) {
    this.checkPhoneLength($event.target.value);
  }

  checkPhoneLength(value: string) {
    if(value.length >= 4) {
      this.communication.setShouldSetDefaultSelected(true);
    }
  }

  onCheckChange(event) {
    this.snap();
    this.showLenderError = false;

    let lenderUp = [];
    const lenderList: FormArray = this.form.get('lendersList') as FormArray;
    lenderList.controls.forEach((ctrl: UntypedFormControl) => {
      if (event.target.value == ctrl.value.id) {
        if (event.target.checked) {
          ctrl.value.checked = true;
        } else {
          ctrl.value.checked = false;
        }
      }
      lenderUp.push(ctrl.value);
    });

    while (lenderList.length !== 0) {
      lenderList.removeAt(0)
    }

    lenderUp.forEach((lender) => {
      lenderList.push(new UntypedFormControl(lender));
    });

    let i: number = 0;
    const lenderArray: FormArray = this.form.get('lenders') as FormArray;
    if(event.target.checked){
      lenderArray.push(new UntypedFormControl(event.target.value));
    } else {
      let i: number = 0;
      lenderArray.controls.forEach((ctrl: UntypedFormControl) => {
        if(ctrl.value == event.target.value) {
          lenderArray.removeAt(i);
          return;
        }

        i++;
      });
    }

    if (!this.validateLenders() && this.isUncheckedValidation) {
      this.showLenderError = true;
    }
  }

  onCheckChangeTop(event) {
    // this.snap();
    if(event.target.checked) {

    } else {
      this.analyticsService.trackGoal(47);
    }
  }

  reInitLenderList() {
    const lenderArray: FormArray = this.form.get('lenders') as FormArray;
    const lenderList: FormArray = this.form.get('lendersList') as FormArray;
    while (lenderArray.length !== 0) {
      lenderArray.removeAt(0)
    }
    while (lenderList.length !== 0) {
      lenderList.removeAt(0)
    }

    this.finalLenders.forEach(value => {
      if (value.checked) {
        lenderArray.push(new UntypedFormControl(value?.id));
      }
      lenderList.push(new UntypedFormControl(value));
    });
  }

  phoneSubmit(isNeedLenderValidation) {
    if (isNeedLenderValidation) {
      if (this.validateLenders()) {
        this.submit();
      } else {
        this.showLenderError = true;
      }
    } else {
      this.submit()
    }
  }

  validateLenders() {
    let is_valid = false;
    const lenderList: FormArray = this.form.get('lendersList') as FormArray;
    lenderList.controls.forEach((ctrl: UntypedFormControl) => {
      if (ctrl.value.checked) {
        is_valid = true;
      }
    });

    return is_valid;
  }
}
